import { render, staticRenderFns } from "./CreateAssessment.vue?vue&type=template&id=2562deb6"
import script from "./CreateAssessment.vue?vue&type=script&lang=js"
export * from "./CreateAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports